import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['PACK EDITABLE DE DOCUMENTOS PROFESIONALES™', 'SISTEMA DE OPERACIÓN DIARIA™', 'KIT OPERATIVO DE MOSTRADOR™', 'Ahorrar tiempo y verte más profesional', 'Organizar mejor tu flujo diario y reducir caos', 'Manejar situaciones difíciles con claridad y seguridad'];
export function SistemaOperativoSection() {
  return <section className="bg-white py-8 px-5" data-id="element-269">
      <div className="max-w-xl mx-auto" data-id="element-270">
        <div className="text-center mb-12" data-id="element-271">
          <span className="bg-brand-primary/10 text-brand-primary text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest mb-6 inline-block border border-brand-primary/20" data-id="element-272">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-4" data-id="element-273">
            🧠 ¿QUÉ AGREGA EL KIT DE IMPLEMENTACIÓN?
          </h2>
          <p className="text-base text-slate-500 font-medium max-w-md mx-auto" data-id="element-274">
            El MegaPack te entrega el sistema. Pero esto te ayuda a{' '}
            <span className="text-brand-primary font-bold" data-id="element-275">
              IMPLEMENTARLO más rápido
            </span>{' '}
            en tu trabajo real.
          </p>
        </div>

        <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 mb-10 shadow-sm" data-id="element-276">
          <h3 className="text-lg font-black text-center mb-8 uppercase tracking-wider text-brand-primary" data-id="element-277">
            💥 ESTO INCLUYE:
          </h3>
          <div className="space-y-4" data-id="element-278">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white p-4 rounded-xl border border-slate-100 shadow-sm" data-id="element-279">
                <CheckCircle className="text-brand-primary flex-shrink-0" size={24} data-id="element-280" />
                <span className="text-sm md:text-base font-bold text-slate-700" data-id="element-281">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="bg-brand-primary/5 border border-brand-primary/10 p-6 rounded-2xl text-center" data-id="element-282">
          <p className="text-slate-900 font-bold text-lg mb-2" data-id="element-283">
            DIFERENCIA CRÍTICA
          </p>
          <p className="text-sm text-slate-600" data-id="element-284">
            SI SOLO COMPRÁS EL MEGAPACK:{' '}
            <span className="font-bold" data-id="element-285">aprendés.</span>
            <br data-id="element-286" />
            SI ELEGÍS EL SISTEMA COMPLETO:{' '}
            <span className="font-bold text-brand-primary" data-id="element-287">
              aprendés + implementás mucho más rápido.
            </span>
          </p>
        </div>
      </div>
    </section>;
}